<template>
    <section>
        <!-- <Row>
            <Col span="24">

            </Col>
        </Row> -->
        <div class="img_box">
            <div>
                <div class="Slogan">
                    <p>海马行打造加油站智能服务系统</p>
                </div>
                <ul>
                    <li>
                        <div class="icon_box">
                            <img src="../../assets/index/支付.png" alt="社区">
                        </div>
                        <p class="intro_title">聚合支付</p>
                        <p class="intro_cont">强大的集合支付功能，实现便捷支付，无感支付，一键加油。</p>
                    </li>
                    <li>
                        <div class="icon_box">
                            <img src="../../assets/index/社区.png" alt="社区">
                        </div>
                        <p class="intro_title">社区商圈</p>
                        <p class="intro_cont">联合社区周边商户建设异业联盟，为用户提供优惠产品和服务，提升用户粘度及活跃度。</p>
                    </li>
                    <li>
                        <div class="icon_box">
                            <img src="../../assets/index/车牌付.png" alt="社区">
                        </div>
                        <p class="intro_title">人工智能车牌付</p>
                        <p class="intro_cont">车牌识别、人脸识别实现车辆免密支付，提升加油效率，缓解站内拥堵。</p>
                    </li>
                    <li>
                        <div class="icon_box">
                            <img src="../../assets/index/手机.png" alt="社区">
                        </div>
                        <p class="intro_title">线上便利店体系</p>
                        <p class="intro_cont">建设民营加油站连锁便利店，以新零售颠覆传统便利店销售模式，提升非油销量。</p>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 产品展示 -->
        <div>
            <div class="product_show">
                <div class="part_title">
                    <p>产品展示</p>
                    <span></span>
                </div>
                <div>
                    <Row>
                        <Col span="12">
                            <div class="hm_product_show">
                                <p class="hm_title">海马行</p>
                                <p class="hm_intro">致力于为加油站和广大车主提供高效便捷的互联网智能场景服务。帮助加油站从传统售油模式转变为出行服务提供商，建立油站与用户之间的社交关系。</p>
                                <div>
                                    <img src="../../assets/index/流程.png" alt="海马行">
                                </div>
                            </div>
                        </Col>
                        <Col span="12">
                            <img src="../../assets/index/hmjy.png" alt="海马行">
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
        <!-- 产品体系 01 -->
        <div style="background: #FAFAFC;">
            <div class="product_sys">
                <div class="part_title">
                    <p>产品体系</p>
                    <span></span>
                </div>
                <Row>
                    <Col span="12">
                        <div class="product_01">
                            <img src="../../assets/index/zhyzglxt.png" alt="海马行">
                        </div>
                    </Col>
                    <Col span="12">
                        <div class="product_intro_01">
                            <span class="title">智慧油站管理系统</span>
                            <span class="num">01</span>
                            <p class="content">通过信息化平台及人工智能技术，实现一键加油、经营分析，会员管理，支付清算，车主服务，经营咨询等功能，为车主提供便捷灵活的加油体验，为油站提供差异化竞争优势。</p>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
        <!-- 02 -->
        <div>
            <div class="product_sys">
                <div class="part_title"></div>
                <Row>
                    <Col span="12">
                        <div class="product_intro_01">
                            <span class="title">加油站零管系统</span>
                            <span class="num">02</span>
                            <p class="content">供应商管理、商品和出入库管理，极大提高工作效率，为油站提升经营水平提供有力支持。以客户为中心依靠数据驱动经营成为新零售加油站变革的最核心驱动力。</p>
                        </div>
                    </Col>
                    <Col span="12">
                        <div class="product_01">
                            <img src="../../assets/index/jyz0glxt.png" alt="海马行">
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
        <!-- 03 -->
        <div style="background: #FAFAFC;">
            <div class="product_sys">
                <div class="part_title"></div>
                <Row>
                    <Col span="12">
                        <div class="product_01">
                            <img src="../../assets/index/hlw+yxpt.png" alt="海马行">
                        </div>
                    </Col>
                    <Col span="12">
                        <div class="product_intro_01">
                            <span class="title">互联网+营销平台</span>
                            <span class="num">03</span>
                            <p class="content">利用互联网营销理念为油站传统销售手段赋能，通过活动模板，智能统计、过程监控、车主召回等功能，为油站提供灵活的营销活动，拓展营销渠道，建设油站会员新生态。</p>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
        <!-- 04 -->
        <div>
            <div class="product_sys">
                <div class="part_title"></div>
                <Row>
                    <Col span="12">
                        <div class="product_intro_01">
                            <span class="title">大数据及用户画像</span>
                            <span class="num">04</span>
                            <p class="content">整合油站业务、车主出行、周边社区、车辆消费等数据，通过用户画像提供千人千面的定制化服务，最终形成大数据营销平台。</p>
                        </div>
                    </Col>
                    <Col span="12">
                        <div class="product_01">
                            <img src="../../assets/index/hlw+yxpt.png" alt="海马行">
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
        <!-- 05 -->
        <div style="background: #FAFAFC;">
            <div class="product_sys">
                <div class="part_title"></div>
                <Row>
                    <Col span="12">
                        <div class="product_01">
                            <img src="../../assets/index/jyzdjzxfu.png" alt="海马行">
                        </div>
                    </Col>
                    <Col span="12">
                        <div class="product_intro_01">
                            <span class="title">经营指导及咨询服务</span>
                            <span class="num">05</span>
                            <p class="content">系统提供定制化的品控检测、客诉代处理、采购推荐、经理人学院等咨询指导，快速提升油站管理质量和运行效率，规范行业经营标准和服务质量。</p>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
        <!-- 核心优势 -->
        <div>
            <div class="advantage">
                <div class="part_title">
                    <p>核心优势</p>
                    <span></span>
                </div>
                <ul>
                    <li>
                        <div class="icon_box_02">
                            <img src="../../assets/index/0flzftx.png" alt="海马行">
                        </div>
                        <p class="intro_title">聚合支付</p>
                        <!-- <p class="intro_cont">对接工行、拉卡拉、富友等具有费率竞争力的支付渠道，打造多种支付方式并存的零费率支付体系，为油站提供灵活支付手段。</p> -->
                        <p class="intro_cont">一次接入所有主流支付渠道，丰富的交易场景，为用户提供完美支付体验。</p>
                    </li>
                    <li>
                        <div class="icon_box_02">
                            <img src="../../assets/index/sqsq.png" alt="海马行">
                        </div>
                        <p class="intro_title">社区商圈</p>
                        <p class="intro_cont">以加油站为中心联合社区周边商户建设异业联盟生态体系，为社区用户提供优惠产品及生活服务，提升用户粘度及活跃度。</p>
                    </li>
                    <li>
                        <div class="icon_box_02">
                            <img src="../../assets/index/cpf.png" alt="海马行">
                        </div>
                        <p class="intro_title">车牌付</p>
                        <p class="intro_cont">通过车牌识别，人脸识别实现车辆加油后的免密支付功能，通过站端摄像头或手机扫车牌识别。有效提升加油效率，降低站内拥堵。</p>
                    </li>
                    <li>
                        <div class="icon_box_02">
                            <img src="../../assets/index/xsbldtx.png" alt="海马行">
                        </div>
                        <p class="intro_title">线上便利店体系</p>
                        <p class="intro_cont">建设民营加油站连锁品牌便利店，以新零售颠覆传统便利店销售模式，打造差异化竞争优势，提升加油站非油品销售量。</p>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 合作伙伴 -->
        <div style="background: #FAFAFC;">
            <div class="partner">
                <div class="part_title">
                    <p>合作伙伴</p>
                    <span></span>
                </div>
                <div class="partner_logo">
                    <img src="../../assets/index/bottom_bg.png" alt="">
                    <!-- <div>
                        <img src="../../assets/index/首页(最终版1)_21.png" alt="海马行">
                        <img src="../../assets/index/首页(最终版1)_32.png" alt="海马行">
                        <img src="../../assets/index/首页(最终版1)_24.png" alt="海马行">
                        <img src="../../assets/index/首页(最终版1)_22.png" alt="海马行">
                        <img src="../../assets/index/首页(最终版1)_33.png" alt="海马行">
                    </div>
                    <div>
                        <img src="../../assets/index/首页(最终版1)_03.png" alt="海马行">
                        <img src="../../assets/index/首页(最终版1)_05.png" alt="海马行">
                        <img src="../../assets/index/首页(最终版1)_07.png" alt="海马行">
                        <img src="../../assets/index/首页(最终版1)_09.png" alt="海马行">
                        <img src="../../assets/index/首页(最终版1)_34.png" alt="海马行">
                    </div>
                    <div>
                        <img src="../../assets/index/首页(最终版1)_18.png" alt="海马行">
                        <img src="../../assets/index/首页(最终版1)_20.png" alt="海马行">
                        <img src="../../assets/index/首页(最终版1)_11.png" alt="海马行">
                    </div> -->
                </div>
            </div>
        </div>
        <div class="right_tab">
            <div @mouseenter="enterPhone" @mouseleave="outPhone" class="phone">
                <img src="../../assets/index/电话.png" alt="联系电话">
                <div class="phone_box" :class="{phone_enter:phone_show, phone_out:phone_hide}">
                    4009030180
                </div>
            </div>
            <div class="apply">
                <div @click="showModal" class="apply_title">
                    申<br>请<br>试<br>用
                </div>
                <div v-if="showHide" class="apply_modal">
                    <div class="apply_model_title">申请试用</div>
                    <div class="apply_model_content">
                        <p>留下您的联系方式等待客服回访或拨打客服热线：4009030180</p>
                        <Form :model="connectForm" ref="connectForm"  :rules="rule" label-position="left" :label-width="80">
                            <FormItem label="姓名" prop="name">
                                <Input v-model="connectForm.name" ></Input>
                            </FormItem>
                            <FormItem label="手机号" prop="phone">
                                <Input v-model="connectForm.phone"></Input>
                            </FormItem>
                            <FormItem label="油站名称" prop="stationName">
                                <Input v-model="connectForm.stationName"></Input>
                            </FormItem>
                        </Form>
                        <Button @click="submitForm" style="background:#0093e9;color:white;" size='large' long shape="circle">提 交</Button>
                        <Icon @click="closeModal" class="close_modal" type="md-remove" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    data() {
        const validateName = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('输入内容不能为空'));
            } else {
                callback();
            }
        };

        return {
            phone_show: false,
            phone_hide: true,
            showHide: false,
            connectForm: {
                name: '',
                phone: '',
                stationName: ''
            },
            rule: {
                    name: [
                        // { required: true, message: '请输入姓名', trigger: 'blur' },
                        {required: true, validator: validateName, trigger: 'blur'}
                    ],
                    phone: [
                        {required: true, validator: validateName, trigger: 'blur'}
                    ],
                    stationName: [
                        {required: true, validator: validateName, trigger: 'blur'}
                    ]
                }
        }
    },
    methods: {
        enterPhone(){
            this.phone_show = true;
            this.phone_hide = false;
        },
        outPhone(){
            this.phone_show = false;
            this.phone_hide = true;
        },
        closeModal(){
            this.showHide = false;
        },
        showModal(){
            this.showHide = true;
        },
        submitForm(){
            this.$refs['connectForm'].validate((valid) => {
                if (valid) {
                    axios.post('/icc/save',this.connectForm)
                    .then((res) => {
                        if(res.data.code=='0'){
                            this.$Message.success(res.data.msg);
                            this.connectForm = {
                                name: '',
                                phone: '',
                                stationName: '',
                            };
                            this.showHide = false;
                        }else{
                            this.$Message.warning(res.data.msg);
                        }
                    }).catch((error) => {
                        this.$Message.warning(error);
                    });
                } else {
                    this.$Message.warning('请输入完整信息！');
                }
            })
        }
    },
}
</script>
<style scoped>
    .img_box{
        position: relative;
        background-image: url('../../assets/index/背景.jpg');
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    .img_box>div{
        width: 1200px;
        margin: 0 auto;
    }
    .Slogan p{
        padding-top: 150px;
        margin-bottom: 100px;
        font-size: 64px;
        width: 100%;
        height: 300px;
        color: white;
    }
    .img_box ul{
        padding-bottom: 100px;
    }
    .img_box ul li{
        display: inline-block;
        width: 283px;
        height: 362px;
        margin-right: 20px;
        color: white;
        text-align: center;
        background-image: url('../../assets/index/背景框.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        vertical-align: bottom;
        box-shadow: 0 0 8px white;
    }
    .img_box ul li:hover{
        transform: translateY(-5%);
        transition: all linear .2s;
    }
    .img_box ul li:last-child{
        margin-right: 0;
    }
    .icon_box{
        width: 60px;
        height: 60px;
        margin: 60px auto 0;
    }
    .intro_title{
        padding-top: 36px;
        padding-bottom: 36px;
        font-size: 20px;
    }
    .intro_cont{
        padding: 0 36px;
        text-align: left;
        font-size: 16px;
    }
    /* 产品展示 */
    .product_show{
        height: 663px;
        width: 1200px;
        margin: 0 auto;
    }
    .part_title{
        font-size: 30px;
        padding-top: 48px;
        padding-bottom: 80px;
    }
    .part_title span{
        padding-left: 70px;
        border-top: 2px solid #0094EB;
        font-size: 0;
    }
    .hm_product_show{
        text-align: left;
    }
    .hm_product_show .hm_title{
        font-size: 28px;
        padding-bottom: 28px;
    }
    .hm_product_show .hm_intro{
        font-size: 16px;
        margin-bottom: 120px;
    }
    .hm_product_show div{
        padding-left: 65px;
    }
    /* 产品体系 */
    .product_sys{
        height: 589px;
        width: 1200px;
        margin: 0 auto;
    }
    .product_01{
        width: 560px;
        height: 332px;
    }
    .product_intro_01{
        text-align: left;
        padding-top: 40px;
    }
    .product_intro_01 .title{
        font-size: 24px;
    }
    .product_intro_01 .num{
        font-size: 52px;
        color: #EAEAEC;
        padding-left: 20px;
    }
    .product_intro_01 .content{
        width: 560px;
        font-size: 16px;
        padding-top: 20px;
    }
    /* 核心优势 */
    .advantage{
        height: 581px;
        width: 1200px;
        margin: 0 auto;
    }
    .advantage .part_title{
        padding-bottom: 48px;
    }
    .advantage ul li{
        display: inline-block;
        width: 283px;
        margin-right: 20px;
        vertical-align: top;
    }
    .advantage ul li:last-child{
        margin-right: 0;
    }
    .advantage .icon_box_02{
        margin: 0 auto;
    }
    .advantage .intro_title{
        font-size: 24px;
        color: #333;
        padding-bottom: 24px;
    }
    .advantage .intro_cont{
        font-size: 14px;
        color: #666;
    }
    /* 合作伙伴 */
    .partner{
        height: 510px;
        width: 1200px;
        margin: 0 auto;
    }
    .partner .part_title{
        padding-bottom: 40px;
    }
    /* .partner_logo div{
        padding-bottom: 20px;
    }
    .partner_logo div:first-child img{
        margin-right: 65px;
    } */
    .partner_logo{
        padding-bottom: 50px;
    }
    /* 右侧联系方式 */
    .right_tab{
        position: fixed;
        top: 20vh;
        right: 20px;
    }
    .right_tab .phone, .right_tab .apply{
        width: 60px;
        background: #0093e9;
        margin-bottom: 20px;
        border-radius: 30px;
        color: white;
    }
    .right_tab .phone:hover, .right_tab .apply:hover{
        background-color: #035acc;
    }
    .right_tab .phone{
        height: 60px;
        line-height: 60px;
    }
    .right_tab .apply{
        height: 200px;
    }
    .phone .phone_box{
        color: #0093e9;
        background: #fff;
        position: absolute;
        top: 0;
        right: 80px;
        width: 160px;
        border-radius: 8px;
        box-shadow: 0 0 8px 2px #ddd;
        font-size: 18px;
    }
    .phone_enter{
        display: block;
    }
    .phone_out{
        display: none;
    }
    .apply_title{
        padding-top: 24px;
        font-size: 24px;
        cursor: pointer;
    }
    .apply_modal{
        position: absolute;
        top: 80px;
        right: 80px;
        width: 300px;
        box-shadow: 0 0 8px 2px #ddd;
    }
    .apply_model_title{
        background: #0093e9;
        height: 56px;
        font-size: 18px;
        color: white;
        text-align: left;
        line-height: 56px;
        padding-left: 32px;
    }
    .apply_model_content{
        background: #fff;
        height: 320px;
        padding: 20px 32px;
    }
    .apply_model_content p{
        font-size: 15px;
        color: #666;
        text-align: left;
        padding-bottom: 20px;
    }
    .close_modal{
        position: absolute;
        top: 8px;
        right: 18px;
        color: white;
        font-size: 36px;
    }
</style>



